import type { LangMessages } from '@pushwoosh/dumb-components/polyglot';

import { messages as enMessages } from './messages_en';
import { DEFAULT_LANGUAGE } from './languages';
import type { PolyglotMessages } from './type';

// English ships in the main bundle as a guaranteed, synchronous baseline.
// Every other language is code-split and fetched on demand.
export async function loadMessages(code: string): Promise<LangMessages<PolyglotMessages>> {
  if (code === DEFAULT_LANGUAGE) {
    return enMessages;
  }

  try {
    const module = await import(
      /* webpackChunkName: "messages-[request]" */
      `./messages_${code}`
    );
    return module.messages as LangMessages<PolyglotMessages>;
  } catch {
    // Unknown code or failed chunk — degrade to English rather than break the UI.
    return enMessages;
  }
}
